import { render, staticRenderFns } from "./waitpayorder.vue?vue&type=template&id=2bfaa08b&scoped=true&"
import script from "./waitpayorder.vue?vue&type=script&lang=js&"
export * from "./waitpayorder.vue?vue&type=script&lang=js&"
import style0 from "./waitpayorder.vue?vue&type=style&index=0&id=2bfaa08b&lang=less&scoped=true&"
import style1 from "./waitpayorder.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfaa08b",
  null
  
)

export default component.exports